export default "__VITE_ASSET__DWYnMFNF__"